// extracted by mini-css-extract-plugin
export default {"ComponentsGeneralContainer":"userCreate_ComponentsGeneralContainer__qqyBq","ComponentsContainer":"userCreate_ComponentsContainer__tce36"};